export var UPDATE_TYPE = {
  ADD: 0,
  DELETE: 1,
  UPDATE: 2
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-virtualized-tree/es/contants.js
// module id = 243
// module chunks = 1